export default {
  data() {
    return {
      isMobile: false,
      mobileBreakpoint: 680,
    }
  },

  methods: {
    setMobile() {
      if (window.innerWidth <= this.mobileBreakpoint) this.isMobile = true
      if (window.innerWidth > this.mobileBreakpoint) this.isMobile = false
    },
  },

  created() {
    window.addEventListener('resize', this.setMobile)
    this.setMobile()
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setMobile)
  },
}
